import React from 'react'
import Logo from 'images/header/flip-logo.svg'
import FooterNavigation from './Navigation'
import styled from 'styled-components'
import SocialMediaFooter from './SocialMedia'
import mediaQuery from 'styles/mediaQuery'

const FooterStyle = styled.footer`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  padding: 24px 0;
  ${mediaQuery.desktopMin} {
    padding: 48px 0;
  }
`

const CopyrightContainerStyle = styled.div`
  width: 100%;
  & > p {
    text-align: center;
  }
  ${mediaQuery.mobile} {
    & > p {
      font-size: 12px;
    }
  }
`

const LogoWrapper = styled(Logo)`
  max-width: 150px;
`

const translations = {
  copyright: `HUMANS INC. 2250 E Maple Ave, El Segundo, CA 90245 © ${new Date().getFullYear()} Flip`,
}

const Footer = () => (
  <FooterStyle>
    <LogoWrapper />
    <FooterNavigation />
    <CopyrightContainerStyle>
      <p>{translations.copyright}</p>
    </CopyrightContainerStyle>
    <SocialMediaFooter />
  </FooterStyle>
)

export default Footer
